import API from "./axios";

export function getIdFromCreateResponse(resData) {
  const d = resData?.data ?? resData;
  return d?.id || d?._id || d?.data?.id || d?.data?._id || null;
}

export async function listEnterprises({ q = "", page = 1, limit = 10 } = {}) {
  const res = await API.get("/enterprises", { params: { q, page, limit } });
  return res.data;
}

export async function createEnterprise(payload) {
  const res = await API.post("/enterprises", payload);
  return res.data;
}

export async function updateEnterprise(id, patch) {
  const res = await API.put(`/enterprises/${id}`, patch);
  return res.data;
}

export async function deleteEnterprise(id) {
  const res = await API.delete(`/enterprises/${id}`);
  return res.data;
}

export async function createEnterpriseCommsLog(enterpriseId, log = {}) {
  const res = await API.post(`/communications`, {
    ...log,
    enterprise: enterpriseId,
  });
  return res.data;
}

export async function listEnterpriseCommsLogs(opts = {}) {
  const res = await API.get(`/communications`, { params: opts });
  return res.data;
}

export async function getEnterpriseCommsLogById(id) {
  const res = await API.get(`/communications/${id}`);
  return res.data;
}

export async function getEnterpriseById(id) {
  const res = await API.get(`/enterprises/${id}`);
  return res.data;
}

export async function calculateFare({ enterpriseId, packageId, city, vehicleCategory, distance, duration }) {
  const res = await API.post("/enterprises/calculate-fare", {
    enterpriseId,
    packageId,
    city,
    vehicleCategory,
    distance: Number(distance) || 0,
    duration: Number(duration) || 0,
  });
  return res.data;
}

export async function bulkUploadEnterprises(file) {
  const formData = new FormData();
  formData.append('file', file);

  const res = await API.post("/enterprises/bulk-upload", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return res.data;
}
